import PropTypes from 'prop-types';
import { Popup } from 'cat-ecommerce-alloy';
import HeaderActionsItems from './HeaderActionItems/HeaderActionsItems';
import { getPopperOptions } from './utils';
import { useSelector } from 'react-redux';

const ExportMenuPopup = ({ children, optionList = [] }) => {
  const langId = useSelector(s => s.common?.langId);
  if (!children) {
    return null;
  }

  return (
    <Popup
      popperOptions={getPopperOptions(langId)}
      contents={<HeaderActionsItems optionList={optionList} />}
      initiator={children}
      className="p-0 border-0"
    />
  );
};

ExportMenuPopup.propTypes = {
  children: PropTypes.node,
  optionList: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired
    })
  )
};

export default ExportMenuPopup;
